// document.addEventListener('DOMContentLoaded', () => {
//     const viewport = document.getElementById('InfiniteCanvasViewport');
//     const world = document.getElementById('InfiniteCanvasWorld');
//     const dataScript = document.getElementById('InfiniteCanvasData');

//     if (!viewport || !world || !dataScript) return;

//     let products = [];
//     try {
//         const data = JSON.parse(dataScript.textContent);
//         products = data.products || [];
//     } catch (e) {
//         console.error('Failed to parse product data', e);
//     }

//     // Fallback
//     if (products.length === 0) {
//         console.warn('No products found.');
//         // Optional: Render placeholders/message
//         return;
//     }

//     // Configuration
//     const isMobile = window.innerWidth < 768;
//     const GRID_SIZE = isMobile ? 175 : 350; // Spacing between items (reduced on mobile)
//     const ROWS = 6;       // Grid dimensions to render (visible buffer)
//     const COLS = 8;
//     const FRICTION = 0.92;
//     const STOP_THRESHOLD = 0.1;

//     // State
//     let cameraX = 0;
//     let cameraY = 0;

//     let isDragging = false;
//     let startX = 0, startY = 0;
//     let lastX = 0, lastY = 0;

//     let velX = 0;
//     let velY = 0;

//     // To distinguish click vs drag
//     let currentDragDist = 0;

//     // Animation Loop
//     let rafId;

//     // Initialize Items
//     const items = [];
//     let productIndex = 0;

//     // Pre-calculate grid to satisfy constraints (no neighbors same)
//     const gridProductIndices = new Array(ROWS).fill(0).map(() => new Array(COLS).fill(-1));
//     const usedIndices = new Set();

//     // Helper to get index at wrapped coordinates
//     const getIdx = (r, c) => {
//         const wrappedR = (r + ROWS) % ROWS;
//         const wrappedC = (c + COLS) % COLS;
//         return gridProductIndices[wrappedR][wrappedC];
//     };

//     for (let r = 0; r < ROWS; r++) {
//         for (let c = 0; c < COLS; c++) {
//             const forbidden = new Set();
//             // Check neighbors (including diagonals and wrapping)
//             forbidden.add(getIdx(r, c - 1)); // Left
//             forbidden.add(getIdx(r - 1, c)); // Top
//             forbidden.add(getIdx(r - 1, c - 1)); // Top-Left
//             forbidden.add(getIdx(r - 1, c + 1)); // Top-Right
//             // Also check wrap-around for first row/col to ensure seamless infinite scroll
//             if (r === ROWS - 1) forbidden.add(getIdx(0, c)); // Bottom edge checks Top edge
//             if (c === COLS - 1) forbidden.add(getIdx(r, 0)); // Right edge checks Left edge

//             // Find valid product index
//             let validIndices = [];
//             for (let i = 0; i < products.length; i++) {
//                 if (!forbidden.has(i)) validIndices.push(i);
//             }

//             // Fallback if strict constraints fail (rare with enough products, but safety first)
//             if (validIndices.length === 0) {
//                 validIndices = products.map((_, i) => i); // Allow any if stuck
//             }

//             // Pick random from valid
//             const pick = validIndices[Math.floor(Math.random() * validIndices.length)];
//             gridProductIndices[r][c] = pick;
//         }
//     }

//     // Centered grid generation
//     for (let r = -ROWS / 2; r < ROWS / 2; r++) {
//         for (let c = -COLS / 2; c < COLS / 2; c++) {
//             const item = document.createElement('div');
//             item.className = 'canvas-item';

//             // Map loop coordinates to 0..ROWS/COLS
//             const gridR = r + ROWS / 2;
//             const gridC = c + COLS / 2;
//             const productIndex = gridProductIndices[gridR][gridC];
//             const product = products[productIndex];

//             const link = document.createElement('a');
//             link.href = product.url;
//             link.className = 'canvas-link';

//             // Prevent Default on Click if we dragged
//             link.addEventListener('click', (e) => {
//                 if (currentDragDist > 5) {
//                     e.preventDefault();
//                     e.stopPropagation();
//                 }
//             });

//             if (product.image) {
//                 const img = document.createElement('img');
//                 img.src = product.image;
//                 img.loading = "lazy";
//                 img.draggable = false; // Prevent native image drag
//                 link.appendChild(img);
//             } else {
//                 link.textContent = product.title;
//                 link.style.display = 'flex';
//                 link.style.alignItems = 'center';
//                 link.style.justifyContent = 'center';
//                 link.style.height = '200px';
//                 link.style.background = '#eee';
//                 link.style.color = '#333';
//             }

//             // Create Info Container (Title + Price)
//             const info = document.createElement('div');
//             info.className = 'canvas-item-info';

//             const title = document.createElement('span');
//             title.className = 'canvas-item-title';
//             title.textContent = product.title;

//             const price = document.createElement('span');
//             price.className = 'canvas-item-price';
//             price.textContent = product.price;

//             info.appendChild(title);
//             info.appendChild(price);
//             link.appendChild(info);

//             item.appendChild(link);
//             world.appendChild(item);

//             // Randomize layout slightly for organic feel
//             const offsetX = (Math.random() - 0.5) * 80;
//             const offsetY = (Math.random() - 0.5) * 80;
//             const staggerY = (c % 2) * (GRID_SIZE * 0.5); // Stagger every other column
//             const depth = 0; // Flattened depth

//             items.push({
//                 el: item,
//                 x: c * GRID_SIZE + offsetX,
//                 y: r * GRID_SIZE + staggerY + offsetY,
//                 z: depth
//             });

//             // Initial position
//             item.style.transform = `translate3d(${items[items.length - 1].x}px, ${items[items.length - 1].y}px, 0) translate(-50%, -50%)`;
//         }
//     }

//     function update() {
//         // Apply Momentum
//         if (!isDragging) {
//             cameraX += velX;
//             cameraY += velY;

//             velX *= FRICTION;
//             velY *= FRICTION;

//             if (Math.abs(velX) < STOP_THRESHOLD) velX = 0;
//             if (Math.abs(velY) < STOP_THRESHOLD) velY = 0;
//         }

//         // Apply global transform to the world container
//         // This is much more performant than updating every item every frame
//         world.style.transform = `translate3d(${cameraX.toFixed(1)}px, ${cameraY.toFixed(1)}px, 0)`;

//         // World wrapping logic
//         // We only check and update individual items if they go off-screen
//         const width = COLS * GRID_SIZE;
//         const height = ROWS * GRID_SIZE;
//         const halfWidth = width / 2;
//         const halfHeight = height / 2;

//         items.forEach(item => {
//             // Calculate screen position relative to the camera
//             // We use the reverse logic: item.x + cameraX
//             let distX = item.x + cameraX;
//             let distY = item.y + cameraY;

//             // If item is too far right/bottom, move it back (wrap to left/top)
//             // If item is too far left/top, move it forward (wrap to right/bottom)
//             // We shift the item's virtual position (item.x) by +/- width

//             let changed = false;

//             // Wrap X
//             // Use while loops to handle fast movement or small worlds
//             while (distX > halfWidth) {
//                 item.x -= width;
//                 distX -= width;
//                 changed = true;
//             }
//             while (distX < -halfWidth) {
//                 item.x += width;
//                 distX += width;
//                 changed = true;
//             }

//             // Wrap Y
//             while (distY > halfHeight) {
//                 item.y -= height;
//                 distY -= height;
//                 changed = true;
//             }
//             while (distY < -halfHeight) {
//                 item.y += height;
//                 distY += height;
//                 changed = true;
//             }

//             // Only update DOM if the item's logical position changed (wrapping)
//             if (changed) {
//                 item.el.style.transform = `translate3d(${item.x}px, ${item.y}px, ${item.z}px) translate(-50%, -50%)`;
//             }
//         });

//         rafId = requestAnimationFrame(update);
//     }

//     // Event Listeners
//     viewport.addEventListener('mousedown', e => {
//         isDragging = true;
//         currentDragDist = 0;

//         startX = e.clientX;
//         startY = e.clientY;
//         lastX = startX;
//         lastY = startY;

//         // Stop momentum on grab
//         velX = 0;
//         velY = 0;

//         viewport.style.cursor = 'grabbing';
//     });

//     window.addEventListener('mouseup', () => {
//         if (isDragging) {
//             isDragging = false;
//             viewport.style.cursor = 'grab';
//         }
//     });

//     window.addEventListener('mousemove', e => {
//         if (!isDragging) return;
//         e.preventDefault();

//         const dx = e.clientX - lastX;
//         const dy = e.clientY - lastY;

//         // Update Camera
//         cameraX += dx;
//         cameraY += dy;

//         // Track velocity for momentum
//         velX = dx;
//         velY = dy;

//         // Track total distance to distinguish tap vs drag
//         currentDragDist += Math.hypot(dx, dy);

//         lastX = e.clientX;
//         lastY = e.clientY;
//     });

//     // Touch Support
//     viewport.addEventListener('touchstart', e => {
//         isDragging = true;
//         currentDragDist = 0;

//         startX = e.touches[0].clientX;
//         startY = e.touches[0].clientY;
//         lastX = startX;
//         lastY = startY;

//         velX = 0;
//         velY = 0;
//     }, { passive: false });

//     window.addEventListener('touchend', () => {
//         isDragging = false;
//     });

//     window.addEventListener('touchmove', e => {
//         if (!isDragging) return;

//         const clientX = e.touches[0].clientX;
//         const clientY = e.touches[0].clientY;

//         const dx = clientX - lastX;
//         const dy = clientY - lastY;

//         if (Math.abs(dx) > 2 || Math.abs(dy) > 2) e.preventDefault();

//         cameraX += dx;
//         cameraY += dy;
//         velX = dx;
//         velY = dy;

//         currentDragDist += Math.hypot(dx, dy);

//         lastX = clientX;
//         lastY = clientY;
//     }, { passive: false });

//     // Start Loop
//     update();
// });

/**
 * Infinite Canvas — Tilemap Chunking Pattern
 *
 * Inspired by game engine tile rendering:
 *  - A small fixed pool of DOM nodes covers only the visible viewport (+ 1-tile bleed)
 *  - The entire pool moves as one via a single CSS transform (sub-tile precision)
 *  - When the camera crosses a tile boundary we *reassign* tile content — no new nodes,
 *    no layout thrash, just innerHTML/src swaps on the existing pool elements
 *  - Result: O(visible tiles) DOM nodes, O(1) style mutations per frame during pan
 */

/**
 * Infinite Canvas — Tilemap Chunking Pattern
 *
 * Inspired by game engine tile rendering:
 *  - A small fixed pool of DOM nodes covers only the visible viewport (+ 1-tile bleed)
 *  - The entire pool moves as one via a single CSS transform (sub-tile precision)
 *  - When the camera crosses a tile boundary we *reassign* tile content — no new nodes,
 *    no layout thrash, just innerHTML/src swaps on the existing pool elements
 *  - Result: O(visible tiles) DOM nodes, O(1) style mutations per frame during pan
 */

// Runs straight away when loaded after the canvas markup (infinite-canvas.liquid), so the
// tiles exist before the first frame; otherwise waits for the DOM.
function initInfiniteCanvas() {
    const viewport = document.getElementById('InfiniteCanvasViewport');
    const world = document.getElementById('InfiniteCanvasWorld');
    const dataEl = document.getElementById('InfiniteCanvasData');

    if (!viewport || !world || !dataEl) return;
    const camera = viewport.querySelector('.infinite-canvas-camera');

    const bgVideo = viewport.querySelector('.infinite-canvas-bg-video');
    if (bgVideo) bgVideo.playbackRate = 0.85;

    // Haptics via local web-haptics.js — deferred, so it may not exist yet when this runs;
    // created on first use instead
    let _wh = null;
    const haptic = (type) => {
        _wh = _wh || (window.WebHaptics ? new window.WebHaptics({ debug: true }) : null);
        _wh?.trigger(type);
    };

    // ─── Data ────────────────────────────────────────────────────────────────────
    let products = [];
    try {
        products = (JSON.parse(dataEl.textContent) || {}).products || [];
    } catch (e) { console.error('InfiniteCanvas: bad JSON', e); }
    if (!products.length) return;
    const allProducts = products.slice();

    // ─── Config ──────────────────────────────────────────────────────────────────
    const isMobile = window.innerWidth < 768;
    const TILE = isMobile ? 130 : 260;   // px — base tile size
    const SPACING = isMobile ? 230 : 360; // px — grid cell spacing (larger = more breathing room)
    const STAGGER = SPACING * 0.5;          // vertical column stagger
    const BLEED = 2;                      // extra tiles beyond the fully zoomed-out viewport
    const FRICTION   = 0.92;
    const STOP       = 0.08;
    const WHEEL_MULT = 2;
    const JITTER = 0.23;                   // fraction of TILE used for random offset

    // ─── Deterministic layout noise ──────────────────────────────────────────────
    // Seeded so the same tile always gets the same jitter (prevents flicker on reassign)
    function tileRng(tx, ty) {
        // Simple integer hash → [0,1)
        let h = (tx * 1619 + ty * 31337) ^ ((tx ^ ty) * 6271);
        h = Math.imul(h ^ (h >>> 16), 0x45d9f3b);
        h = Math.imul(h ^ (h >>> 16), 0x45d9f3b);
        h ^= (h >>> 16);
        return ((h >>> 0) / 0xffffffff);
    }

    function tileProduct(tx, ty) {
        const r = (tileRng(tx, ty) * products.length) | 0;
        return products[r];
    }

    function tileOffset(tx, ty) {
        const rx = (tileRng(tx * 7 + 1, ty) - 0.5) * SPACING * JITTER;
        const ry = (tileRng(tx, ty * 7 + 3) - 0.5) * SPACING * JITTER;
        return { rx, ry };
    }


    // ─── Pool ─────────────────────────────────────────────────────────────────────
    // Work out how many tiles we need to cover the viewport
    function poolDims() {
        // +2 ensures we always cover a partial tile on each edge before BLEED kicks in.
        // BLEED*2 covers both left+right (or top+bottom).
        // Stagger can push a tile down by STAGGER (0.5 tile), so rows gets +1 extra.
        // Divide by MIN_ZOOM so the pool still covers the viewport when fully zoomed out.
        const cols = Math.ceil(viewport.clientWidth / MIN_ZOOM / SPACING) + 2 + BLEED * 2;
        const rows = Math.ceil(viewport.clientHeight / MIN_ZOOM / SPACING) + 2 + BLEED * 2 + 1;
        return { cols, rows };
    }

    let pool = [];      // flat array of { el, tx, ty }
    let poolCols = 0;
    let poolRows = 0;

    function createTileEl() {
        const item = document.createElement('div');
        item.className = 'canvas-item';

        const link = document.createElement('a');
        link.className = 'canvas-link';

        const bg = document.createElement('div');
        bg.className = 'canvas-item-bg';

        const img = document.createElement('img');
        img.draggable = false;
        img.loading = 'eager';
        img.style.opacity = '0';
        img.addEventListener('load', () => {
            const soldOut = item.classList.contains('is-sold-out');
            img.style.opacity = soldOut ? '0.5' : '1';
            img.style.filter = soldOut ? 'grayscale(100%)' : 'none';
        });

        const info = document.createElement('div');
        info.className = 'canvas-item-info';

        const titleEl = document.createElement('span');
        titleEl.className = 'canvas-item-title';

        const priceEl = document.createElement('span');
        priceEl.className = 'canvas-item-price';

        const soldOutEl = document.createElement('span');
        soldOutEl.className = 'canvas-item-sold-out';
        soldOutEl.textContent = 'SOLD OUT';

        info.appendChild(titleEl);
        info.appendChild(priceEl);
        link.appendChild(bg);
        link.appendChild(img);
        link.appendChild(soldOutEl);
        link.appendChild(info);
        item.appendChild(link);
        world.appendChild(item);

        // Block navigation when the user dragged
        link.addEventListener('click', e => {
            if (dragDist > 5) { e.preventDefault(); e.stopPropagation(); }
        });

        return { el: item, link, img, bg, titleEl, priceEl, soldOutEl, tx: 0, ty: 0 };
    }

    // True only during the first layout (see assignTile)
    let firstLayout = false;

    function assignTile(tile, tx, ty) {
        tile.tx = tx;
        tile.ty = ty;

        const product = tileProduct(tx, ty);
        if (!product) return;
        const { rx, ry } = tileOffset(tx, ty);

        // Pixel position within the world layer
        // (world layer itself is translated by the camera sub-tile offset)
        const stagger = ((tx % 2) + 2) % 2 === 1 ? STAGGER : 0;
        const px = tx * SPACING + rx;
        const py = ty * SPACING + stagger + ry;

        tile.worldPx = px;
        tile.worldPy = py;
        tile.el.style.transform = `translate3d(${px}px, ${py}px, 0) translate(-50%, -50%)`;

        if (tile.img.dataset.rawSrc !== product.image) {
            tile.img.dataset.rawSrc = product.image || '';
            if (firstLayout) {
                // First paint (and so the page transition's snapshot): show the photos
                // straight away, decoded with the frame, instead of fading them in after
                // their load events — on a fresh page those fire late even when cached.
                const soldOut = tile.el.classList.contains('is-sold-out');
                tile.img.decoding = 'sync';
                tile.img.style.opacity = soldOut ? '0.5' : '1';
            } else {
                tile.img.style.opacity = '0';
            }
            tile.img.src = product.image || '';
            tile.img.alt = product.title || '';
            // Cached images fire load synchronously before the listener runs — reveal immediately
            if (tile.img.complete && tile.img.naturalWidth > 0) {
                const soldOut = tile.el.classList.contains('is-sold-out');
                tile.img.style.opacity = soldOut ? '0.5' : '1';
                tile.img.style.filter = soldOut ? 'grayscale(100%)' : 'none';
            }
        }
        tile.link.href = product.url || '#';
        tile.titleEl.textContent = product.title || '';
        tile.priceEl.textContent = product.price || '';

        if (product.sold_out) {
            tile.el.classList.add('is-sold-out');
            tile.link.style.pointerEvents = 'none';
            const rotation = Math.floor(tileRng(tx * 13 + 5, ty * 17 + 3) * 91) - 45;
            tile.soldOutEl.style.transform = `translate(-50%, -50%) rotate(${rotation}deg)`;
        } else {
            tile.el.classList.remove('is-sold-out');
            tile.link.style.pointerEvents = '';
        }
    }

    function buildPool() {
        const { cols, rows } = poolDims();
        poolCols = cols;
        poolRows = rows;

        // Remove excess
        while (pool.length > cols * rows) {
            const t = pool.pop();
            world.removeChild(t.el);
        }
        // Add missing
        while (pool.length < cols * rows) {
            pool.push(createTileEl());
        }
    }

    // ─── Camera state ─────────────────────────────────────────────────────────────
    let cameraX = 0;
    let cameraY = 0;
    let velX = 0;   // frame delta — used for skew/blur only
    let velY = 0;
    let originTX = 0;
    let originTY = 0;
    let rafId = null;

    // ─── Zoom ─────────────────────────────────────────────────────────────────────
    const MIN_ZOOM = 0.4;
    const MAX_ZOOM = 2.5;
    const ZOOM_LERP = 0.1;
    let zoom = 1;
    let targetZoom = 1;


    // ─── Directional skew ─────────────────────────────────────────────────────────
    const MAX_SKEW = 2.5;    // degrees
    const SKEW_FACTOR = 0.08; // vel px/frame → degrees
    const SKEW_LERP = 0.08;  // easing speed (lower = smoother/slower)
    let skewX = 0;
    let skewY = 0;

    // ─── Directional motion blur (SVG feGaussianBlur, separate X/Y axes) ──────────
    const MAX_BLUR = 4;      // px
    const BLUR_FACTOR = 0.15;
    const BLUR_LERP = 0.12;
    let blurX = 0;
    let blurY = 0;

    const svgNS = 'http://www.w3.org/2000/svg';
    const blurSvg = document.createElementNS(svgNS, 'svg');
    blurSvg.setAttribute('style', 'position:absolute;width:0;height:0;pointer-events:none');
    const defs = document.createElementNS(svgNS, 'defs');
    const filter = document.createElementNS(svgNS, 'filter');
    filter.setAttribute('id', 'canvas-motion-blur');
    filter.setAttribute('x', '-20%');
    filter.setAttribute('y', '-20%');
    filter.setAttribute('width', '140%');
    filter.setAttribute('height', '140%');
    const feBlur = document.createElementNS(svgNS, 'feGaussianBlur');
    feBlur.setAttribute('stdDeviation', '0 0');
    filter.appendChild(feBlur);
    defs.appendChild(filter);
    blurSvg.appendChild(defs);
    document.body.appendChild(blurSvg);

    // ─── Layout tiles from current origin ─────────────────────────────────────────
    function layoutPool() {
        for (let row = 0; row < poolRows; row++) {
            for (let col = 0; col < poolCols; col++) {
                const tile = pool[row * poolCols + col];
                assignTile(tile, originTX + col, originTY + row);
            }
        }
    }

    // ─── Sync world transform & handle tile-crossing ──────────────────────────────
    // The world element is shifted by the *sub-tile* remainder of the camera position.
    // Whole-tile movements are handled by reassigning tile content (the pool slides).
    function syncWorld() {
        // Anchor: pool [0,0] tile lives at pixel (originTX * TILE, originTY * TILE) in world-space.
        // World-space offset relative to viewport centre:
        //   screenPos = worldPos + cameraX
        // We want pool origin to sit at viewport's top-left minus BLEED tiles:
        //   pool_origin_world = originTX * TILE
        //   desired_screen    = -BLEED * TILE  (i.e. just off-screen to the left)
        //   world_translate   = desired_screen - pool_origin_world
        // But that's the initial snap. For infinite scroll we just track camera continuously.

        // The world layer is already centred by CSS (top/left 50%), so world-pixel 0,0
        // sits at the viewport centre and only the camera offset is applied here.
        const tx = cameraX;
        const ty = cameraY;

        const targetSkewX = Math.max(-MAX_SKEW, Math.min(MAX_SKEW, velX * SKEW_FACTOR));
        const targetSkewY = Math.max(-MAX_SKEW, Math.min(MAX_SKEW, velY * SKEW_FACTOR));
        skewX += (targetSkewX - skewX) * SKEW_LERP;
        skewY += (targetSkewY - skewY) * SKEW_LERP;

        const targetBlurX = Math.min(MAX_BLUR, Math.abs(velX) * BLUR_FACTOR);
        const targetBlurY = Math.min(MAX_BLUR, Math.abs(velY) * BLUR_FACTOR);
        blurX += (targetBlurX - blurX) * BLUR_LERP;
        blurY += (targetBlurY - blurY) * BLUR_LERP;
        feBlur.setAttribute('stdDeviation', `${blurX.toFixed(2)} ${blurY.toFixed(2)}`);

        world.style.transform = `translate3d(${Math.round(tx)}px,${Math.round(ty)}px,0) skewX(${skewX.toFixed(2)}deg) skewY(${skewY.toFixed(2)}deg)`;

        // ── Focal overlay blur — O(1), GPU-accelerated via backdrop-filter ──────────
        const speed = (blurX + blurY) * 1.5;
        focalOverlay.style.backdropFilter = `blur(${speed.toFixed(2)}px)`;
        focalOverlay.style.webkitBackdropFilter = `blur(${speed.toFixed(2)}px)`;

        // ── Tile boundary crossing ─────────────────────────────────────────────────
        // Dead-zone hysteresis: only shift the pool origin once the camera has drifted
        // more than 0.75 tiles from the current origin's centre. This prevents Math.round
        // oscillating at the 0.5-tile boundary (which triggered layoutPool every frame
        // and caused visible tile-content swapping on mobile).
        const snapCX = originTX + Math.floor(poolCols / 2);
        const snapCY = originTY + Math.floor(poolRows / 2);
        const driftX = (-cameraX / SPACING) - snapCX;
        const driftY = (-cameraY / SPACING) - snapCY;

        if (Math.abs(driftX) > 0.75 || Math.abs(driftY) > 0.75) {
            const camTX = Math.round(-cameraX / SPACING);
            const camTY = Math.round(-cameraY / SPACING);
            originTX = camTX - Math.floor(poolCols / 2);
            originTY = camTY - Math.floor(poolRows / 2);
            layoutPool();   // Reassign content — no DOM create/destroy, just src + text swaps
        }
    }

    // ─── RAF loop ─────────────────────────────────────────────────────────────────
    function tick() {
        if (!isDragging) {
            cameraX += velX;
            cameraY += velY;
            velX *= FRICTION;
            velY *= FRICTION;
            if (Math.abs(velX) < STOP) velX = 0;
            if (Math.abs(velY) < STOP) velY = 0;
        }
        zoom += (targetZoom - zoom) * ZOOM_LERP;
        camera.style.transform = `scale(${zoom.toFixed(4)})`;
        // Sync zoom scroller slider (late-bound — slider may not exist yet on first tick)
        const sl = viewport._zoomSlider;
        if (sl) {
            const v = Math.round(((zoom - MIN_ZOOM) / (MAX_ZOOM - MIN_ZOOM)) * 100);
            if (Number(sl.value) !== v) sl.value = v;
        }
        syncWorld();
        if (isDragging || velX !== 0 || velY !== 0 || Math.abs(targetZoom - zoom) > 0.001) {
            rafId = requestAnimationFrame(tick);
        } else {
            rafId = null;
        }
    }

    function startRAF() {
        if (!rafId) rafId = requestAnimationFrame(tick);
    }

    // ─── Input ────────────────────────────────────────────────────────────────────
    let isDragging = false;
    let lastX = 0, lastY = 0;
    let dragDist = 0;

    function onDragStart(cx, cy) {
        isDragging = true;
        dragDist = 0;
        _lastNudgedKey = null;
        lastX = cx;
        lastY = cy;
        velX = 0;
        velY = 0;
        viewport.style.cursor = 'grabbing';
        startRAF();
    }
    let _lastNudgedKey = null;
    function onDragMove(cx, cy) {
        if (!isDragging) return;
        const dx = (cx - lastX) / zoom;
        const dy = (cy - lastY) / zoom;
        cameraX += dx;
        cameraY += dy;
        velX = dx;
        velY = dy;
        dragDist += Math.hypot(dx, dy);
        lastX = cx;
        lastY = cy;

        // Fire nudge haptic when a tile passes through the viewport centre
        const threshold = SPACING * 0.45;
        const centeredTile = pool.find(t =>
            Math.abs(t.worldPx + cameraX) < threshold &&
            Math.abs(t.worldPy + cameraY) < threshold
        );
        if (centeredTile) {
            const key = `${centeredTile.tx},${centeredTile.ty}`;
            if (key !== _lastNudgedKey) {
                _lastNudgedKey = key;
                haptic('nudge');
            }
        } else {
            _lastNudgedKey = null;
        }
    }
    function onDragEnd() {
        isDragging = false;
        viewport.style.cursor = 'grab';
        startRAF();
    }

    // Desktop wheel = zoom. Touch events are handled separately — exclude them here.
    // deltaMode 1 = lines, 2 = pages; normalise to pixels as Lenis did.
    viewport.addEventListener('wheel', e => {
        const deltaY = e.deltaY * (e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? window.innerHeight : 1);
        const prevZoom = targetZoom;
        targetZoom = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, targetZoom * (1 - deltaY * 0.002)));
        if (targetZoom !== prevZoom) haptic('rigid');
        startRAF();
    }, { passive: true });

    viewport.addEventListener('mousedown', e => onDragStart(e.clientX, e.clientY));
    window.addEventListener('mousemove', e => { if (isDragging) { e.preventDefault(); onDragMove(e.clientX, e.clientY); } }, { passive: false });
    window.addEventListener('mouseup', () => onDragEnd());

    // Mobile: single touch = pan, two touches = pinch to zoom
    let pinchDist = 0;
    let _lastPinchHapticZoom = 0;

    viewport.addEventListener('touchstart', e => {
        if (e.touches.length === 1) {
            onDragStart(e.touches[0].clientX, e.touches[0].clientY);
        } else if (e.touches.length === 2) {
            isDragging = false;
            pinchDist = Math.hypot(
                e.touches[0].clientX - e.touches[1].clientX,
                e.touches[0].clientY - e.touches[1].clientY
            );
        }
    }, { passive: false });

    window.addEventListener('touchmove', e => {
        if (e.touches.length === 1 && isDragging) {
            const dx = e.touches[0].clientX - lastX;
            const dy = e.touches[0].clientY - lastY;
            if (Math.abs(dx) > 2 || Math.abs(dy) > 2) e.preventDefault();
            onDragMove(e.touches[0].clientX, e.touches[0].clientY);
        } else if (e.touches.length === 2 && pinchDist > 0) {
            e.preventDefault();
            const d = Math.hypot(
                e.touches[0].clientX - e.touches[1].clientX,
                e.touches[0].clientY - e.touches[1].clientY
            );
            const prevPinchZoom = targetZoom;
            targetZoom = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, targetZoom * (d / pinchDist)));
            pinchDist = d;
            if (targetZoom !== prevPinchZoom && Math.abs(targetZoom - _lastPinchHapticZoom) > 0.05) {
                haptic('rigid');
                _lastPinchHapticZoom = targetZoom;
            }
            startRAF();
        }
    }, { passive: false });

    window.addEventListener('touchend', e => {
        if (e.touches.length < 2) pinchDist = 0;
        if (e.touches.length === 0) onDragEnd();
    });

    // Resize — rebuild pool if viewport changes dramatically
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            buildPool();
            layoutPool();
        }, 200);
    });

    // ─── Init ─────────────────────────────────────────────────────────────────────
    buildPool();

    // Seed origin so the pool is centred on the viewport
    originTX = -Math.floor(poolCols / 2);
    originTY = -Math.floor(poolRows / 2);
    firstLayout = true;
    layoutPool();
    firstLayout = false;

    // Focal blur overlay — backdrop-filter + radial mask, sharp centre / blurred edges
    const focalOverlay = document.createElement('div');
    focalOverlay.className = 'canvas-focal-overlay';
    viewport.appendChild(focalOverlay);

    // ─── Zoom Scroller ────────────────────────────────────────────────────────────
    const zoomScroller = document.createElement('div');
    zoomScroller.className = 'canvas-zoom-scroller';

    const zoomPlus = document.createElement('button');
    zoomPlus.className = 'canvas-zoom-btn';
    zoomPlus.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true"><path d="M8 3v10M3 8h10"/></svg>';
    zoomPlus.setAttribute('aria-label', 'Zoom in');

    const zoomSlider = document.createElement('input');
    zoomSlider.type = 'range';
    zoomSlider.className = 'canvas-zoom-slider';
    zoomSlider.min = '0';
    zoomSlider.max = '100';
    zoomSlider.step = '1';
    zoomSlider.value = String(Math.round(((zoom - MIN_ZOOM) / (MAX_ZOOM - MIN_ZOOM)) * 100));

    const zoomMinus = document.createElement('button');
    zoomMinus.className = 'canvas-zoom-btn';
    zoomMinus.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true"><path d="M3 8h10"/></svg>';
    zoomMinus.setAttribute('aria-label', 'Zoom out');

    zoomScroller.appendChild(zoomPlus);
    zoomScroller.appendChild(zoomSlider);
    zoomScroller.appendChild(zoomMinus);
    zoomScroller.style.cssText = 'position:absolute;right:20px;top:50%;transform:translateY(-50%);z-index:9999;';
    document.body.appendChild(zoomScroller);

    zoomSlider.addEventListener('input', () => {
        const prevZoom = targetZoom;
        targetZoom = MIN_ZOOM + (Number(zoomSlider.value) / 100) * (MAX_ZOOM - MIN_ZOOM);
        if (targetZoom !== prevZoom) haptic('rigid');
        startRAF();
    });

    zoomPlus.addEventListener('click', () => {
        targetZoom = Math.min(MAX_ZOOM, targetZoom * 1.15);
        haptic('light');
        startRAF();
    });
    zoomMinus.addEventListener('click', () => {
        targetZoom = Math.max(MIN_ZOOM, targetZoom / 1.15);
        haptic('light');
        startRAF();
    });

    // Expose slider so tick() can sync it (late-bound — tick was defined before slider)
    viewport._zoomSlider = zoomSlider;

    // ─── Filter UI ───────────────────────────────────────────────────────────────
    const filterBar = document.createElement('div');
    filterBar.className = 'canvas-filter-bar';

    const FILTERS = [
        { label: 'All',          match: null },
        { label: 'Beanies',      match: p => p.title.toLowerCase().includes('beanie') },
        { label: 'Caps',         match: p => p.title.toLowerCase().includes('cap') },
    ];

    function applyFilter(index) {
        const { match } = FILTERS[index];
        const filtered = match ? allProducts.filter(match) : allProducts;

        filterBar.querySelectorAll('.canvas-filter-btn').forEach((btn, i) => {
            btn.classList.toggle('is-active', i === index);
        });

        // Blur + fade the single world container (one GPU layer, not N tiles)
        world.classList.add('canvas-world--hiding');

        setTimeout(() => {
            products = filtered.length ? filtered : allProducts;
            pool.forEach(tile => { tile.img.dataset.rawSrc = ''; });
            layoutPool();
            syncWorld();
            world.classList.remove('canvas-world--hiding');
            world.classList.add('canvas-world--showing');
            setTimeout(() => {
                world.classList.remove('canvas-world--showing');
                startRAF();
            }, 450);
        }, 300);
    }

    const filterGroup = document.createElement('div');
    filterGroup.className = 'canvas-filter-group';
    FILTERS.forEach(({ label }, i) => {
        const btn = document.createElement('button');
        btn.className = 'canvas-filter-btn' + (i === 0 ? ' is-active' : '');
        btn.textContent = label;
        btn.addEventListener('click', () => { haptic('selection'); applyFilter(i); });
        filterGroup.appendChild(btn);
    });
    filterBar.appendChild(filterGroup);

    filterBar.style.cssText = 'position:fixed;bottom:48px;left:50%;transform:translateX(-50%);z-index:9999;';
    document.body.appendChild(filterBar);

    // The zoom control joins the filter bar after a divider. Desktop: one horizontal
    // bar. Mobile: an L in the bottom-right corner, filters along the bottom and zoom up
    // the right side, the divider across the corner (infinite-canvas.css). The divider, a
    // slanted stroke, is a button that folds the controls into itself and back out.
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const filterDivider = document.createElement('button');
    filterDivider.type = 'button';
    filterDivider.className = 'canvas-filter-divider';
    filterDivider.setAttribute('aria-expanded', 'true');
    filterDivider.setAttribute('aria-label', 'Hide controls');
    filterBar.append(filterDivider, zoomScroller);

    // Collapse / expand. Each side shrinks into the divider (filters by width; zoom by
    // width on desktop, height on mobile) while its contents fade. On desktop the bar's
    // centre moves to the divider's in step, so the divider itself never moves; the
    // collapsed button stays there until it's expanded back to the middle. On mobile the
    // bar is anchored to the corner the divider sits in, so it folds into it as it is.
    // Sizes are measured before and after the class change and animated between.
    const FOLD = { duration: 520, easing: 'cubic-bezier(0.65, 0, 0.35, 1)' };
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let collapsed = false;
    let foldTimer = null;

    function measureFold() {
        const bar = filterBar.getBoundingClientRect();
        const divider = filterDivider.getBoundingClientRect();
        const zoomAxis = mobileQuery.matches ? 'height' : 'width';
        return {
            filter: filterGroup.getBoundingClientRect().width,
            zoom: zoomScroller.getBoundingClientRect()[zoomAxis],
            filterMargin: getComputedStyle(filterGroup).marginRight,
            zoomMargin: getComputedStyle(zoomScroller)[mobileQuery.matches ? 'marginBottom' : 'marginLeft'],
            divider: divider.width,
            dividerMargins: [getComputedStyle(filterDivider).marginLeft, getComputedStyle(filterDivider).marginRight],
            barCentre: bar.left + bar.width / 2,
            dividerCentre: divider.left + divider.width / 2,
        };
    }

    function setCollapsed(next) {
        if (next === collapsed) return;
        collapsed = next;
        const mobile = mobileQuery.matches;
        const from = measureFold();
        clearTimeout(foldTimer);
        [filterGroup, zoomScroller, filterDivider, filterBar].forEach((el) => el.getAnimations().forEach((a) => a.cancel()));

        filterBar.classList.toggle('is-collapsed', next);
        filterBar.classList.remove('is-folded');
        filterGroup.inert = next;
        zoomScroller.inert = next;
        filterDivider.setAttribute('aria-expanded', String(!next));
        filterDivider.setAttribute('aria-label', next ? 'Show controls' : 'Hide controls');
        if (!mobile) filterBar.style.left = next ? `${from.dividerCentre}px` : '50%';
        const to = measureFold();
        // Collapsed, the bar takes the plain square shape (on mobile the L can't shrink
        // that far cleanly); swapped in once the fold has (nearly) closed
        const fold = () => filterBar.classList.toggle('is-folded', collapsed);

        if (reducedMotion.matches) return fold();

        const zoomAxis = mobile ? 'height' : 'width';
        const zoomMarginProp = mobile ? 'marginBottom' : 'marginLeft';
        filterGroup.animate(
            { width: [`${from.filter}px`, `${to.filter}px`], marginRight: [from.filterMargin, to.filterMargin] },
            FOLD
        );
        zoomScroller.animate(
            { [zoomAxis]: [`${from.zoom}px`, `${to.zoom}px`], [zoomMarginProp]: [from.zoomMargin, to.zoomMargin] },
            FOLD
        );
        filterDivider.animate(
            {
                width: [`${from.divider}px`, `${to.divider}px`],
                marginLeft: [from.dividerMargins[0], to.dividerMargins[0]],
                marginRight: [from.dividerMargins[1], to.dividerMargins[1]],
            },
            FOLD
        );
        if (!mobile) filterBar.animate({ left: [`${from.barCentre}px`, `${to.barCentre}px`] }, FOLD);

        // Contents fade out early in a collapse, and in late in an expansion
        const fade = next
            ? { opacity: [1, 0], duration: FOLD.duration * 0.55, easing: 'ease-in' }
            : { opacity: [0, 1], duration: FOLD.duration * 0.55, delay: FOLD.duration * 0.45, easing: 'ease-out', fill: 'backwards' };
        const { opacity, ...timing } = fade;
        [filterGroup, zoomScroller].forEach((el) => el.animate({ opacity }, timing));

        if (next) foldTimer = setTimeout(fold, FOLD.duration * 0.9);
    }

    filterDivider.addEventListener('click', () => {
        haptic('light');
        setCollapsed(!collapsed);
    });

    // Mobile: make the zoom arm as long as the filters' arm. The zoom column is two 36px
    // buttons + two 2px gaps around the slider = 76px + slider.
    function matchZoomToFilter() {
        if (!mobileQuery.matches) return zoomScroller.style.removeProperty('--ize-zoom-len');
        const buttons = filterBar.querySelectorAll('.canvas-filter-btn');
        const span =
            buttons[buttons.length - 1].getBoundingClientRect().right - buttons[0].getBoundingClientRect().left;
        zoomScroller.style.setProperty('--ize-zoom-len', `${Math.max(40, span - 76)}px`);
    }
    // Keep the controls above the fixed footer: publish how far its text row (copyright +
    // policies) reaches up from the bottom of the screen, for the CSS. This script runs
    // while the page is still parsing (inside <main>), before the footer exists, so the
    // footer is looked up once the DOM is complete.
    const footerRow = () => document.querySelector('.footer__copyright') || document.querySelector('.footer');
    function measureFooter() {
        const row = footerRow();
        if (!row) return;
        const reach = Math.max(0, window.innerHeight - row.getBoundingClientRect().top);
        document.documentElement.style.setProperty('--ize-footer-h', `${Math.round(reach)}px`);
    }
    function watchFooter() {
        measureFooter();
        const row = footerRow();
        if (row && window.ResizeObserver) new ResizeObserver(measureFooter).observe(row);
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', watchFooter, { once: true });
    } else {
        watchFooter();
    }
    window.addEventListener('resize', measureFooter);
    document.fonts?.ready.then(measureFooter);

    matchZoomToFilter();
    mobileQuery.addEventListener('change', matchZoomToFilter);
    window.addEventListener('resize', matchZoomToFilter);
    document.fonts?.ready.then(matchZoomToFilter);

    viewport.style.cursor = 'grab';
    startRAF();
}

if (document.getElementById('InfiniteCanvasData')) {
    initInfiniteCanvas();
} else {
    document.addEventListener('DOMContentLoaded', initInfiniteCanvas);
}